<template>
    <v-breadcrumbs :items="breadCrumbs" class="breadcrumb-wrapper">
        <template #item="{ item }">
            <v-breadcrumbs-item
                :to="item.href"
                :disabled="item.disabled"
                exact
            >
                <v-btn
                :color="item.home ? '#1B475D' : buttonColor"
                :text="item.home"
                elevation="4"
                class="breadcrumb-button"
                :class="{'color-white': !item.home}"
                >
                    <v-icon class="breadcrumb-icon">{{ item.icon }} </v-icon>
                    <div v-if="activeText !== undefined && item.disabled" class="breadcrumb-text" >{{ activeText }}</div>
                    <div v-else class="breadcrumb-text" >{{ $t(item.text) }}</div>
                </v-btn>
            </v-breadcrumbs-item>
        </template>
        <template #divider>
            <v-icon class="breadcrumb-divider">mdi-chevron-right</v-icon>
        </template>
    </v-breadcrumbs>
</template>

<style lang="scss">
.breadcrumb-wrapper{
    padding: 0px !important;
}
.breadcrumb-icon {
    font-size: 7vh !important;
}
.breadcrumb-text{
    margin-left: .5vw;
    text-transform: none;
    font: normal normal normal 3vh/4vh 'RobotoBold' !important;
}
.breadcrumb-divider{
    font-size: 8vh !important;
    color: $font-color !important;
}
.breadcrumb-button{
    border-radius: 1.2vh !important;
    height: 8vh !important;
}

.color-white{
    color: white !important;
}
</style>
<script>
export default {
    props: {
        buttonColor: String,
        activeText: String,
    },
    computed: {
        breadCrumbs() {
            if (typeof this.$route.meta.breadCrumb === "function") {
                return this.$route.meta.breadCrumb.call(this, this.$route);
            }
            return this.$route.meta.breadCrumb;
        },
    }
}
</script>
